import Home from "../components/HomePage/home";
import ClientsHome from "../components/Client/clients-home";
import ClientLookup from "../components/Client/client-lookup";
import ClientDetails from "../components/Client/Details/client-details";
import ClientProfile from "../components/Client/Details/client-profile";
import SchoolsHome from "../components/Client/Schools/schools-home";
import SchoolForm from "../components/Client/Schools/school-form";
import DistrictAdmins from "../components/Client/DistrictAdmins/district-admins";
import DistrictAdminForm from "../components/Client/DistrictAdmins/district-admin-form";
import PhysiciansTable from "../components/Client/Physicians/physicians-table";
import ProcessHome from "../components/Process/process-home";
import ClientRoster from "../components/Process/client-roster";
import Notes from "../components/Process/notes";
import GapsInService from "../components/Client/Details/gaps-in-service";
import DocumentLookup from "../components/Process/document-lookup";
import ProvidersHome from "../components/Providers/providers-home";
import ProvidersTable from "../components/Providers/providers-table";
import ProviderForm from "../components/Providers/provider-form";
import ReportsHome from "../components/Reports/reports-home";
import SessionReports from "../components/Reports/session-reports";
import Error from "../components/Security/error";
import Callback from "../components/Security/callback";
import PageNotFound from "../components/Shared/page-not-found";

export const routes = [
  {
    name: "Home",
    path: "/",
    redirect: "/client/lookup",
    icon: "home",
    title: "Home",
    component: Home,
    onNavBar: false,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "ClientsHome",
    path: "/clients",
    icon: "users",
    title: "Clients",
    component: ClientsHome,
    onNavBar: true,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: "ClientLookup",
        path: "/client/lookup",
        icon: "users",
        title: "Client Lookup",
        component: ClientLookup,
        onNavBar: true,
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: "NewClient",
        path: "/client/new",
        icon: "users",
        title: "New Client",
        component: ClientProfile,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          eiAdmin: true,
          seitAdmin: true,
        },
      },
      {
        name: "ClientDetails",
        path: "/client/details",
        icon: "users",
        title: "Client Chart",
        component: ClientDetails,
        onNavBar: false,
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: "Schools",
        path: "/schools",
        icon: "users",
        title: "Schools",
        component: SchoolsHome,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
      {
        name: "NewSchool",
        path: "/schools/new",
        icon: "users",
        title: "New School",
        component: SchoolForm,
        onNavBar: false,
        props: true,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
      {
        name: "SchoolForm",
        path: "/schools/edit",
        icon: "users",
        title: "School Form",
        component: SchoolForm,
        onNavBar: false,
        props: true,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
      {
        name: "DistrictAdmins",
        path: "/district-admins",
        icon: "users",
        title: "District Admins",
        component: DistrictAdmins,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
      {
        name: "DistrictAdminForm",
        path: "/district-admins/form",
        icon: "users",
        title: "District Admin Form",
        component: DistrictAdminForm,
        onNavBar: false,
        props: true,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
      {
        name: "PhysiciansTable",
        path: "/physicians",
        icon: "users",
        title: "Physician Lookup",
        component: PhysiciansTable,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          admin: true,
        },
      },
    ],
  },
  {
    name: "ProvidersHome",
    path: "/providers",
    icon: "users",
    title: "Providers",
    component: ProvidersHome,
    onNavBar: true,
    meta: {
      requiresAuth: true,
      seitAdmin: true,
    },
    children: [
      {
        name: "ProviderLookup",
        path: "/providers/lookup",
        icon: "users",
        title: "Provider Lookup",
        component: ProvidersTable,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
      {
        name: "NewProvider",
        path: "/providers/new",
        icon: "users",
        title: "New Provider",
        component: ProviderForm,
        onNavBar: false,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
      {
        name: "ProviderForm",
        path: "/providers/edit",
        icon: "users",
        title: "Provider Form",
        component: ProviderForm,
        onNavBar: false,
        props: true,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
    ],
  },
  {
    name: "process",
    path: "/process",
    icon: "users",
    title: "Process",
    component: ProcessHome,
    onNavBar: true,
    meta: {
      requiresAuth: true,
      eiAdmin: true,
      seitAdmin: true,
      sc: true,
    },
    children: [
      {
        name: "ClientRoster",
        path: "/process/client-roster",
        icon: "users",
        title: "Client Roster",
        component: ClientRoster,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          seitAdmin: true,
        },
      },
      {
        name: "notes",
        path: "/process/notes",
        icon: "users",
        title: "Session Note Lookup",
        component: Notes,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          eiAdmin: true,
          sc: true,
        },
      },
      {
        name: "GapsInService",
        path: "/process/gaps-in-service",
        icon: "users",
        title: "Gaps in Service Submission",
        component: GapsInService,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          eiAdmin: true,
        },
      },
      {
        name: "DocumentLookup",
        path: "/process/documents",
        icon: "users",
        title: "Document Lookup",
        component: DocumentLookup,
        onNavBar: true,
        meta: {
          requiresAuth: true,
          eiAdmin: true,
          seitAdmin: true,
        },
      },
    ],
  },
  {
    name: "reports",
    path: "/reports",
    icon: "users",
    title: "Reports",
    component: ReportsHome,
    onNavBar: true,
    meta: {
      requiresAuth: true,
      admin: true,
    },
    children: [
      {
        name: "SessionReports",
        path: "/reports/session-reports",
        icon: "file-excel",
        title: "Session Reports",
        component: SessionReports,
        onNavBar: true,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    name: "Error",
    path: "/error",
    title: "Error",
    component: Error,
    onNavBar: false,
  },
  {
    name: "Callback",
    path: "/callback",
    title: "Callback",
    component: Callback,
    onNavBar: false,
    onHomePage: false,
  },
  {
    name: "PageNotFound",
    path: "*",
    title: "Page Not Found",
    component: PageNotFound,
    onNavBar: false,
  },
];
